/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PreviewShiftScheduleRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {PreviewShiftScheduleResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const previewShiftSchedule = (request: PreviewShiftScheduleRequest, options?: CashRequestOptions) => post<PreviewShiftScheduleRequest, PreviewShiftScheduleResponse>("/2.0/cash/preview-shift-schedule", request, {...options, rejectOnError: true })